import React, { Component } from 'react'

export default class PendingWorkOrderItem extends Component {
  render() {
    return (
      <div>pendingWorkOrderItem</div>
    )
  }
}